module.exports = __webpack_public_path__ + "static/media/dont_help.a64bafef.svg";